import { Box } from '@mantine/core';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
}

/** Wordmark used in the header, footer, and 404. Served from /public. */
export function Logo({ size = 'md' }: LogoProps) {
  const height = size === 'sm' ? 28 : size === 'lg' ? 48 : 36;

  return (
    <Box style={{ display: 'inline-flex', alignItems: 'center' }}>
      <img
        src="/clancy-tuning-logo.png"
        alt="Clancy Tuning"
        height={height}
        style={{ height, width: 'auto', display: 'block' }}
      />
    </Box>
  );
}
